import { TransitI } from '../interfaces/transit.interface'
import { TransitService } from '../services/transit.service'
import { TransitGetTTNSResponseT } from '../types/transit.types'

const transitService = new TransitService()

class TransitRealisation implements TransitI {
    getTTNS(number: string): Promise<TransitGetTTNSResponseT> {
        return transitService.getTTNS(number)
    }

    setDeliveryDate(tripNumber: string, cityName: string): Promise<void> {
        return transitService.setDeliveryDate(tripNumber, cityName)
    }
}

export const TRANSIT = new TransitRealisation()
